import { useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { BookButton, BookModal, BookTexField, ImageUploader } from '../../components';
import { BookValidation } from '../Books/validation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CreateBook, UpdateBook } from "../../DAL/Books/books";
import { enqueueSnackbar } from "notistack";

const BookModals = ({
  open,
  setOpen,
  action,
  singleBook,
  tableCells,
  handleGetBookData,
  languageData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const handleAddBook = async(values) => { 
    setIsLoading(true);
    const data = {
        author: values?.author,
        bookName: values?.bookName,
        bookNo: values?.bookNo,
        coverImage: values?.coverImage,
      };
    const response = await CreateBook(data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      handleGetBookData()
      setOpen(false);
      formik.handleReset();
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const handleUpdateBook = async(values) => {
    setIsLoading(true);
    const data = {
      author: values?.author,
      bookName: values?.bookName,
      bookNo: values?.bookNo,
      languageId: values?.languageId,
      coverImage: values?.coverImage,
    };
    const response = await UpdateBook(values?.id, data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      handleGetBookData()
      setOpen(false);
      formik.handleReset();
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id:
        action !== 'add' && singleBook && singleBook.id
          ? singleBook.id
          : '',
      coverImage:
        action !== 'add' && singleBook && singleBook.coverImage
          ? singleBook.coverImage
          : '',
      author:
        action !== 'add' && singleBook && singleBook.author
          ? singleBook.author
          : '',
      bookName:
        action !== 'add' && singleBook && singleBook.bookName
          ? singleBook.bookName
          : '',
      bookNo:
        action !== 'add' && singleBook && singleBook.bookNo
          ? singleBook.bookNo
          : '',
          languageId:
        action !== 'add' && singleBook && singleBook.languageId
          ? singleBook.languageId
          : '',
    },
    validationSchema: BookValidation,
    onSubmit: values => {   
      setIsLoading(true);
      if (action === 'add') {
        handleAddBook(values);
      } else {
        handleUpdateBook(values);
      }
    },
  });

  return (
    <BookModal
      open={open}
      formik={formik}
      setOpen={setOpen}
      title='Book'
      subtitle={`${action === 'add' ? 'Add' : 'Edit'} Book`}
    >
      <ImageUploader
        name='coverImage'
        imageUrl={formik?.values?.coverImage}
        callBackResponse={imageResponse => formik?.handleChange(imageResponse)}
      />
      {tableCells &&
        tableCells.map(
          t =>
            t.id !== 'actions' &&
            (t.id === 'languageId' && t.id !== 'coverImage' ? (
              <BookTexField
                formik={formik}
                name={t.id}
                label={t.title}
                placeholder={`Enter ${t.title}`}
                key={t.id + 'cell'}
                select={true}
                selectOptions={languageData}
              />
            ) : (
              <BookTexField
                formik={formik}
                name={t.id}
                label={t.title}
                placeholder={`Enter ${t.title}`}
                key={t.id + 'cell'}
              />
            ))
        )}
      <BookButton
        onSubmit={formik.handleSubmit}
        title={`${action === 'add' ? 'Add' : 'Update'}`}
        type='primary'
        variant='contained'
        isLoading={isLoading}
        sx={{
          top: '0.625rem',
          marginBottom: '0.625rem'
        }}
      />
    </BookModal>
  );
};

export default BookModals;

  